import React from "react";
import { Modal } from "reactstrap";
import { Button } from "react-bootstrap";

const EditAddCertificateTypesModal = ({
  editAddCertificateTypesModal,
  setEditAddCertificateTypesModal,
  title,
  loading,
  EditHandler,
  value,
  setValue,
  item,
  index,
}) => {
  return (
    <>
      <Modal
        className="modal-dialog-centered custom-addLang-modal"
        isOpen={editAddCertificateTypesModal}
        toggle={() => setEditAddCertificateTypesModal(false)}
      >
        {/* <ModalBody> */}
        <div className="modal-Header">
          <h2 className="text-center">{title}</h2>
        </div>
        <div className="addlang-modalBody">
          <div className="innerContainer">
            <div className="form-group">
              <input
                type="text"
                placeholder={title}
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </div>
          </div>

          <div className="modal-footer footer-div">
            <div>
              <Button
                className="btn btn-user btn-block btn-cancel"
                onClick={() => setEditAddCertificateTypesModal(false)}
                disabled={loading}
              >
                Cancel
              </Button>
            </div>

            <div>
              <Button
                className="btn btn-user btn-block btn-save"
                disabled={loading}
                onClick={() => EditHandler(item, index)}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
        {/* </ModalBody> */}
      </Modal>
    </>
  );
};

export default EditAddCertificateTypesModal;
